// 应用状态管理
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

export enum AppState {
  Welcome = 'welcome',
  Loading = 'loading',
  Playing = 'playing',
}

interface StatusState {
  appState: AppState;
  loadingProgress: number;
  loadingMessage: string;
  isLoading: boolean;
  error: string | null;
}

const initialState: StatusState = {
  appState: AppState.Welcome,
  loadingProgress: 0,
  loadingMessage: '',
  isLoading: false,
  error: null,
};

const statusSlice = createSlice({
  name: 'status',
  initialState,
  reducers: {
    setAppState: (state, action: PayloadAction<AppState>) => {
      state.appState = action.payload;
    },
    setLoadingProgress: (state, action: PayloadAction<number>) => {
      state.loadingProgress = action.payload;
    },
    setLoadingMessage: (state, action: PayloadAction<string>) => {
      state.loadingMessage = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const {
  setAppState,
  setLoadingProgress,
  setLoadingMessage,
  setIsLoading,
  setError,
} = statusSlice.actions;

export const selectAppState = (state: RootState) => state.status.appState;
export const selectLoadingProgress = (state: RootState) => state.status.loadingProgress;
export const selectLoadingMessage = (state: RootState) => state.status.loadingMessage;
export const selectIsLoading = (state: RootState) => state.status.isLoading;
export const selectError = (state: RootState) => state.status.error;

export default statusSlice.reducer;
